<template>
<ItpBox
  alignItems="center"
>
  <DIV>
    {{ option.contract_number }}

  </DIV>
  <UcContractTypeBadge
    :value="option.contract_type"
    class="mx-3"
    v-if="option.contract_type"
  >
  </UcContractTypeBadge>
  <UcContractStatusBadge
    :value="option.status"
    v-if="option.status"
  >
  </UcContractStatusBadge>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcSuggestContractOption extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  option!: object;

  @Watch('option')
  onOption(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("option")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcSuggestContractOption", UcSuggestContractOption);

</script>